<template>
	<div class="wrap">
		<DelData ref="delDatas"></DelData>
		<codeAdd ref="codeadddy" :dialogVisible="dialogVisible" @datalist="closeWin" :uid="getdata.id" :flag="getdata.flag" :zzName="cy_zz"></codeAdd>
		<Addmore
			:moreAddwin="moreAddwin" 
			downloadName="党员信息表" 
			title="批量新增党费" 
			@downExcel="downExcel" 
			@closeMorewin="closeMorewin"
			@pushData="pushData"></Addmore>
		<div class="navbar">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>党务工作</el-breadcrumb-item>
				<el-breadcrumb-item>党员管理</el-breadcrumb-item>
				<el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="datawrap">
			<div class="treeWrap" v-if="$store.state.user.userinfo.flag!=3">
				<tree @treeSelect="treeSelect"></tree>
			</div>
			<div class="datatable">
				<div class="datas">
					<div class="selectbar">
						<div>
							<el-input
								size="small"
								v-model="getdata.name" @input="getdata.page = 1;totalPage = 0;dataList();" 
								style="margin-right: 10px;width: 200px !important;"  
								placeholder="输入党员姓名搜索">
							</el-input>
							<el-select
								size="small"
							 	style="margin-right: 10px;width: 100px !important;" 
								v-model="getdata.sex" placeholder="性别"
								clearable
								@change="getdata.page = 1;totalPage = 0;dataList();">
								<el-option
									label="男"
									value="男">
								</el-option>
								<el-option
									label="女"
									value="女">
								</el-option>
							</el-select>
						</div>
						<div>
							<el-button type="primary" size="small" @click="delAll">一键删除</el-button>
							<el-button type="primary" size="small" v-if="getdata.flag == 3" @click="dialogVisible = true;$refs.codeadddy.getcode()">批量扫码添加</el-button>
							<el-button type="primary" size="small" v-if="getdata.flag == 3" @click="$router.push({path:'/dyxx_add',query:{type:'add',flag:getdata.flag,uid:getdata.id,cy_zz:cy_zz}})">新增党员</el-button>
							<el-button type="primary" size="small" v-if="getdata.flag == 3" @click="moreAddwin = true">批量新增</el-button>
							<el-button type="primary" size="small" @click="daochu">导出表格</el-button>
						</div>
					</div>
					<div class="selectdata">
						<myTables 
							:tableData="tableData"
							delkey="id"
							@selectList="selectList"
							:tableHeader="tableHeader"
							:loading="true" 
							:indexs="false"
							:selection="true">
						</myTables>
						<Page :totalPage="totalPage" :pageSize="10" @changedata="changedata"></Page>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import tree from '@/components/tree.vue'
	import { dwgl,dygl } from '@/axios'
	import Page from '@/components/page.vue'
	import { Message } from 'element-ui'
	import codeAdd from './components/code.vue'
	import DelData from '@/components/delToast.vue'
	import Addmore from '@/components/moreadd.vue'
	import myTables from '@/components/tables/tables.vue'
	let that;
	export default{
		data(){
			return{
				dialogVisible:false,
				getdata:{
					id: this.$store.state.user.userinfo.id,
					flag: this.$store.state.user.userinfo.flag,
					name:"",
					sex: "",
					sign: 1,
					page: 1
				},
				delList:[],
				cy_zz:this.$store.state.user.userinfo.dw,
				type:1,//1：新增 2：批量新增
				tableData:[],
				totalPage:0,
				moreAddwin:false,//批量新增窗口
				tableHeader: [     // 表头
					{prop: 'u_name', label: '姓名',width:'100'},
					{prop: 'sex', label: '性别',width:'80'},
					{prop: 'cy_zz', label: '所属组织'},
					{prop: 'u_zhiwu_name', label: '身份',width:"110"},
					{prop: 'condition', label: '状态',formatData:function(val){
						if(val == 1){
							return '正常'
						}else{
							return '已转出'
						}
					},width:"110"},
					{prop: 'u_phone', label: '联系电话',width:'180'},
					// 此处为操作栏，不需要可以删除，clickFun绑定此操作按钮的事件
					{
						prop: 'oper', label: '操作', fixed: 'right', width: '114',align:'center',
						oper: [
							{name: '详情', style: {color:'#bb0000'}, clickFun: this.detail,show:true,limit:''},
							{name: '删除', style: {color:'#bb0000'}, clickFun: this.del,show:true,limit:''},
						]
					}
				]
			}
		},
		components:{tree,Page,codeAdd,Addmore,DelData,myTables},
		created(){that = this;},
		methods:{
			// 关闭新增或编辑弹窗
			closeWin(){
				this.dialogVisible = false;
				this.dataList();
			},
			// 关闭批量新增弹窗
			closeMorewin(){
				this.moreAddwin = false;
				this.dataList();
			},
			// 下载批量表格
			downExcel(){
				window.open('http://dj.gxsentu.net/uploads/dj2_file/dy.xls') 
			},
			// 批量上传数据提交
			pushData(value){
				dygl.excelPutData({
					uid: that.getdata.id,
					url: value.src,
					sign: that.getdata.sign
				}).then(res => {
					if(res.code == 200){
						that.closeMorewin();
					}else{
						Message({
							type:"error",
							message:res.msg
						})
					}
				})
			},
			// 数据
			dataList(){
				dwgl.memberAdmin(that.getdata).then(res => {
					if(res.data.pagedata){
						that.tableData = res.data.pagedata;
						that.totalPage = res.data.count;
					}else{
						that.tableData = [];
						that.totalPage = 0;
					}
				})
			},
			// 分页查询
			changedata(current){
				that.getdata.page = current;
				that.dataList();
			},
			// 树形结构筛选
			treeSelect(data){
				that.getdata.id = data.id;
				that.getdata.flag = data.flag;
				that.cy_zz = data.dw;
				that.getdata.page = 1;
				that.dataList();
			},
			// 一键删除
			selectList(value){
				that.delList = value;
			},
			delAll(){
				if(that.delList.length == 0){
					Message.warning('请先选择要删除得数据')
				}else{
					that.delData();
				}
			},
			//	删除操作
			delData(){
				that.$refs.delDatas.showToast(res => {
					if(res){
						dygl.delMember({
							id:that.delList,
						}).then(res => {
							if(res.code == 200){
								Message({
									type: 'success',
									message: '删除成功!'
								})
							}else{
								Message({
									type: 'error',
									message: res.msg
								})
							}
							that.getdata.page = 1;
							that.dataList();
						})
					}
				})
			},
			// 删除
			del(data){
				that.delList = [];
				that.delList = [data.id];
				that.delData();
			},
			// 编辑
			detail(data){
				that.$router.push({
					path:'/dyxx_detail',
					query:{
						flag:data.flag,
						uid:that.getdata.id,
						cy_zz:data.cy_zz,
						id:data.id
					},
				})
			},
			// 导出表格
			daochu(){
				if(that.tableData.length == 0){
					Message({
						type:"warning",
						message:"暂无可导出的数据"
					})
				}else{
					dwgl.exportPartyOrgan(that.getdata);
				}
			}
		},
		mounted() {
			that.$emit('selectTop',4)
			that.dataList();
		}
	}
</script>

<style lang="scss">
	.wrap{
		position: relative;
		height: 100%;
		width: 100%;
		.fengmian {
		    height: 86px;
		    width: 138px;
		    margin: 10px 16px 10px 14px;
		}
	}
</style>

